import { MAP_DATA_CONTROLS_SELECTOR } from "../constants";
import {
  IPassengersMapStationInfo,
  IPassengerStationsMapInfo,
} from "../models";

export const passengerMapIsPickupStation = (
  stationInfo: IPassengersMapStationInfo,
): boolean => !stationInfo?.isHomeAddress;

export interface IPassengersMapStationsSelection {
  pickupStation: number | null;
  homeAddresses: number[];
}

export const getPassengerMapStationsSelection = (
  dict: Map<number, IPassengerStationsMapInfo>,
): IPassengersMapStationsSelection => {
  let pickupStation: number | null = null;
  const homeAddresses: number[] = [];

  for (const v of dict.values()) {
    const si = v?.stationInfo;
    if (!si) {
      continue;
    }

    if (passengerMapIsPickupStation(si)) {
      pickupStation = si.id;
    } else {
      homeAddresses.push(si.id);
    }
  }

  const selection: IPassengersMapStationsSelection = {
    pickupStation,
    homeAddresses,
  };
  return selection;
};

/**
 * Whether a map click actually landed on the in-map control cluster, which sits over the canvas and must
 * not be treated as a click on the map beneath it.
 *
 * Typed structurally on `originalEvent` rather than against one engine's event, so the Leaflet and MapLibre
 * maps can share it — both wrap the same DOM event, and that is all this reads.
 */
export const isControlClick = (e: {
  originalEvent?: { target?: EventTarget | null } | null;
}): boolean => {
  const target = e.originalEvent?.target as HTMLElement | null;

  return !!target?.closest?.(MAP_DATA_CONTROLS_SELECTOR);
};
